import Icons from '@/lib/icons'
import { cn } from '@/lib/utils'
import { Rss } from 'lucide-react'
import { Link } from '@/i18n/navigation'

const tooltipClass = "absolute bottom-full left-1/2 -translate-x-1/2 mb-[8px] whitespace-nowrap px-[10px] py-[4px] rounded-[8px] bg-[#121124]/90 border border-white/[0.08] backdrop-blur-xl text-[12px] font-medium text-white/60 opacity-0 translate-y-1 pointer-events-none transition-all duration-200 group-hover:opacity-100 group-hover:translate-y-0";

const SocialLink = ({
  href,
  label,
  children,
  className,
}: {
  href: string;
  label: string;
  children: React.ReactNode;
  className?: string;
}) => (
  <div className="relative group">
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      className={className}
    >
      {children}
      <span className="sr-only">{label}</span>
    </a>
    <span className={tooltipClass}>{label}</span>
  </div>
);

const EuBadge = ({ label, className }: { label: string; className: string }) => (
  <div className="relative group">
    <Link
      href="/privacy-policy"
      aria-label={label}
      className={className}
    >
      <span
        aria-hidden="true"
        className="w-4 h-4 bg-white"
        style={{
          WebkitMaskImage: "url(/assets/flags/eu.svg)",
          maskImage: "url(/assets/flags/eu.svg)",
          WebkitMaskRepeat: "no-repeat",
          maskRepeat: "no-repeat",
          WebkitMaskPosition: "center",
          maskPosition: "center",
          WebkitMaskSize: "contain",
          maskSize: "contain",
        }}
      />
      <span className="sr-only">{label}</span>
    </Link>
    <span className={tooltipClass}>{label}</span>
  </div>
);

const Socials = ({
    className,
    iconClassName,
    alignment = 'left',
    feedUrl,
    euGdprLabel,
}: {
    className?: string
    iconClassName?: string
    alignment?: 'left' | 'center' | 'right'
    feedUrl?: string
    euGdprLabel?: string
}) => {
  const linkClass = cn('bg-[linear-gradient(180deg,_rgba(18,17,36,0.5)_0%,_#121124_100%)] text-foreground w-[44px] h-[44px] inline-flex items-center justify-center rounded-full hover:bg-[#3a1660] duration-300 transition-colors mobile-social-icon hover:text-white', iconClassName);

  return (
    <div className={cn(className)}>
        <div className={cn('flex justify-center gap-[10px]', alignment === 'left' && 'justify-start', alignment === 'center' && 'justify-center', alignment === 'right' && 'justify-end')}>
            <SocialLink href="https://www.facebook.com/flyingcode" label="Facebook" className={linkClass}>
                <Icons.facebook className={cn("w-4 h-4", iconClassName)} />
            </SocialLink>
            <SocialLink href="https://www.linkedin.com/company/flyingcode" label="LinkedIn" className={linkClass}>
                <Icons.linkedin className={cn("w-4 h-4", iconClassName)} />
            </SocialLink>
            <SocialLink href="https://www.instagram.com/flyingcode" label="Instagram" className={linkClass}>
                <Icons.instagram className={cn("w-4 h-4", iconClassName)} />
            </SocialLink>
            {feedUrl && (
              <SocialLink href={feedUrl} label="RSS Feed" className={linkClass}>
                  <Rss className="w-4 h-4" />
              </SocialLink>
            )}
            {euGdprLabel && <EuBadge label={euGdprLabel} className={linkClass} />}
        </div>
    </div>
  )
}

export default Socials;
